import Script from 'next/script'

function GoogleTagManager({ googleId = 'GTM-NBNJ2RX' }: { googleId?: string }) {
  const gtm_id = googleId

  if (process.env.NEXT_PUBLIC_APP_ENVIRONMENT === 'production') {
    return (
      <Script id='gtm-script' strategy='beforeInteractive'>
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtm_id}');
        `}
      </Script>
    )
  }
  return null
}

export default GoogleTagManager
